import { SequenceManagerAction } from '../actions/SequenceManagerAction';

const FTTHFlowRuleDetailsAction = {
    FTTH_FLOW_RULE_DETAILS_SUCCESS: 'FTTH_FLOW_RULE_DETAILS_SUCCESS',
}

const ftthFlowRuleDetails = (flowRuleValue: any, offerContainerId: any) => {
    return function (dispatch: any) {
        dispatch({ type: FTTHFlowRuleDetailsAction.FTTH_FLOW_RULE_DETAILS_SUCCESS, payload: { flowRuleValue: flowRuleValue, offerContainerId: offerContainerId } });
        dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['FTTHFlowRuleDetails'] });
    }
}

export { FTTHFlowRuleDetailsAction, ftthFlowRuleDetails };